<mat-form-field class="set-border" appearance="fill">
    <mat-label>{{ optionPlaceHolder }}</mat-label>
    <mat-select
        multiple
        [(value)]="updateSelectedDropDownOptions"
        (opened)="onDropdownFocus()"
        (closed)="onDropdownBlur()"
        (keydown)="onEnterKeyPressed($event)"
        tabindex="-1"
    >
        <mat-optgroup>
            <mat-form-field style="width: 100%">
                <input
                    matInput
                    type="text"
                    autocomplete="off"
                    [placeholder]="optionPlaceHolder"
                    [attr.aria-label]="optionPlaceHolder"
                    [(ngModel)]="searchInput"
                    (input)="applyFilter($event)" /></mat-form-field
        ></mat-optgroup>
        <div class="options-container" #optionsContainer  id="custom-field">
            <p class="no-result" *ngIf="showNoResultText">
                {{ isColorType ? 'Color' : 'Size' }} not found
            </p>
            <mat-option
                *ngFor="let option of filteredOptions"
                [value]="option.value"
                (click)="selectFilteredOption(option)"
            >
                <mat-icon
                    [style.visibility]="
                        selectedOptions.includes(option.value)
                            ? 'visible'
                            : 'hidden'
                    "
                    [style.margin-right]="isColorType ? '30px' : '5px'"
                    class="selected-icon"
                    >done</mat-icon
                >
                <span
                    *ngIf="isColorType"
                    [style.background-color]="
                        (option.value != 'multicolor' && option.value != '#Multi-color' && option.value != '#multi-color') ? option.value : null
                    "
                    [class.multi-color]="option.value == 'multicolor' || option.value == '#multi-color'  || option.value == '#Multi-color'"
                    class="color-palette"
                ></span>
                {{ option.label }}
            </mat-option>
        </div>
    </mat-select>
</mat-form-field>
<mat-chip-list #chipList>
    <mat-chip
        *ngFor="let option of selectedOptions"
        [removable]="true"
        (removed)="removeOption(option)"
    >
        <span
            *ngIf="isColorType"
            class="display-color-palette"
            [style.background-color]="(option != 'multicolor' && option != '#Multi-color' && option != '#multi-color' && option != 'Assorted') ? option : null"
            [class.multi-color]="option == 'multicolor' || option == '#multi-color' || option == '#Multi-color'|| option == 'Assorted'"
        ></span>
        {{ getOptionLabel(option) }}
        <img matChipRemove src="/assets/icons/close.svg" alt="" class="ml-10" />
    </mat-chip>
</mat-chip-list>
